import { Company, Office, Staff } from "@/api/company-api";

export default function buildPrivateCompanyData(
  company: Company,
  office: Office
) {
  // 新規作成の時だけフォームの値を使ってStaffを作る
  const s = buildNewStaff(company, office);
  const d = new FormData();
  d.append("company[id]", company.companyId);
  d.append("company[companyTypeId]", String(company.companyTypeId));
  d.append("company[client]", String(company.client));
  d.append("company[vendor]", String(company.vendor));
  d.append("company[family]", String(company.family));
  d.append("company[name]", company.name);
  d.append("company[furigana]", company.furigana);
  d.append("office[id]", office.officeId);
  d.append("office[name]", "(個人)");
  d.append("office[tel1]", office.tel1);
  d.append("office[tel2]", office.tel2);
  d.append("office[fax]", office.fax);
  d.append("office[mail]", office.mail);
  d.append("office[postcode]", office.postcode);
  d.append("office[address]", office.address);
  d.append("office[latitude]", String(office.latitude));
  d.append("office[longitude]", String(office.longitude));
  d.append("office[note]", office.note);
  if (office.cutoffRule) {
    d.append("office[cutoffRule]", String(office.cutoffRule));
  }

  if (office.monthRule || office.monthRule === 0) {
    d.append("office[monthRule]", String(office.monthRule));
  }

  if (office.dayRule) {
    d.append("office[dayRule]", String(office.dayRule));
  }
  d.append("office[profitRate]", String(office.profitRate));
  d.append("office[invoiceNumber]", String(office.invoiceNumber || ""));
  d.append("staff[id]", s.staffId);
  d.append("staff[name]", s.name);
  d.append("staff[tel]", s.tel);
  d.append("staff[mail]", s.mail);
  if (Array.isArray(company.workTypeIds) && company.workTypeIds.length) {
    company.workTypeIds.forEach(id => {
      d.append("workTypeIds[]", String(id));
    });
  }

  return d;
}

function buildNewStaff(company: Company, office: Office): Staff {
  return {
    staffId: "",
    name: company.name,
    tel: office.tel1,
    mail: office.mail,
    ...office.staffList[0]
  };
}
